module.exports = __webpack_public_path__ + "static/media/forex.36910e83.gif";